/**
 * Spectrum Collection — Filter & Sort Drawers
 *
 * Manages:
 *  - Filter drawer (two-panel: category nav + values)
 *  - Sort drawer (left panel desktop / bottom sheet mobile)
 *  - Body scroll lock
 *  - AJAX integration via existing DynamicProductSearch
 */

(function () {
  'use strict';

  var SELECTORS = {
    openBtn: '[data-spectrum-open]',
    filterDrawer: '#SpectrumFilterDrawer',
    sortDrawer: '#SpectrumSortDrawer',
    backdrop: '.spectrum-drawer__backdrop',
    closeBtn: '.spectrum-drawer__close',
    navItem: '.spectrum-drawer__nav-item',
    filterPanel: '.spectrum-drawer__filter-panel',
    applyBtn: '.spectrum-drawer__apply',
    resetBtn: '.spectrum-drawer__reset',
    sortOption: '.spectrum-sort__option',
    filtersForm: '.js-spectrum-filters-form',
    dynamicSearch: 'dynamic-product-search'
  };

  function init() {
    var container = document.querySelector(SELECTORS.dynamicSearch);
    if (!container) return;

    container.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
  }

  function handleClick(e) {
    var target = e.target;

    // Open buttons
    var openBtn = target.closest(SELECTORS.openBtn);
    if (openBtn) {
      e.preventDefault();
      var drawerType = openBtn.getAttribute('data-spectrum-open');
      openDrawer(drawerType);
      return;
    }

    // Close button
    if (target.closest(SELECTORS.closeBtn)) {
      e.preventDefault();
      closeAllDrawers();
      return;
    }

    // Backdrop click
    if (target.matches(SELECTORS.backdrop)) {
      closeAllDrawers();
      return;
    }

    // Category nav switching
    var navItem = target.closest(SELECTORS.navItem);
    if (navItem) {
      e.preventDefault();
      switchFilterCategory(navItem);
      return;
    }

    // Apply / View Results
    if (target.closest(SELECTORS.applyBtn)) {
      e.preventDefault();
      applyFilters();
      return;
    }

    // Reset
    var resetBtn = target.closest(SELECTORS.resetBtn);
    if (resetBtn) {
      e.preventDefault();
      var resetUrl = resetBtn.getAttribute('data-url');
      if (resetUrl) {
        triggerNavigation(resetUrl);
      }
      return;
    }

    // Sort option
    var sortOption = target.closest(SELECTORS.sortOption);
    if (sortOption) {
      e.preventDefault();
      selectSort(sortOption);
      return;
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      closeAllDrawers();
    }
  }

  function openDrawer(type) {
    var selector = type === 'filter' ? SELECTORS.filterDrawer : SELECTORS.sortDrawer;
    var drawer = document.querySelector(selector);
    if (!drawer) return;

    drawer.classList.add('is-open');
    document.body.classList.add('spectrum-drawer-open');

    // Focus the close button for accessibility
    var closeBtn = drawer.querySelector(SELECTORS.closeBtn);
    if (closeBtn) {
      setTimeout(function () { closeBtn.focus(); }, 100);
    }
  }

  function closeAllDrawers() {
    var drawers = document.querySelectorAll('.spectrum-drawer.is-open');
    for (var i = 0; i < drawers.length; i++) {
      drawers[i].classList.remove('is-open');
    }
    document.body.classList.remove('spectrum-drawer-open');
  }

  function switchFilterCategory(navItem) {
    var drawer = navItem.closest('.spectrum-drawer');
    if (!drawer) return;

    var index = navItem.getAttribute('data-filter-index');

    // Update nav active state
    var allNav = drawer.querySelectorAll(SELECTORS.navItem);
    for (var i = 0; i < allNav.length; i++) {
      allNav[i].classList.remove('is-active');
    }
    navItem.classList.add('is-active');

    // Update panel visibility
    var allPanels = drawer.querySelectorAll(SELECTORS.filterPanel);
    for (var j = 0; j < allPanels.length; j++) {
      allPanels[j].classList.remove('is-active');
    }
    var targetPanel = drawer.querySelector(SELECTORS.filterPanel + '[data-filter-index="' + index + '"]');
    if (targetPanel) {
      targetPanel.classList.add('is-active');
    }
  }

  function applyFilters() {
    var form = document.querySelector(SELECTORS.filtersForm);
    if (!form) return;

    closeAllDrawers();

    // Build the URL from form data
    var formData = new FormData(form);
    var params = [];
    var entries = formData.entries();
    var entry = entries.next();

    while (!entry.done) {
      var key = entry.value[0];
      var value = entry.value[1];
      if (value !== '' && value !== undefined) {
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      }
      entry = entries.next();
    }

    var baseUrl = form.getAttribute('data-url') || window.location.pathname;
    var url = baseUrl + (params.length ? '?' + params.join('&') : '');

    triggerNavigation(url);
  }

  function selectSort(option) {
    var sortValue = option.getAttribute('data-sort');
    if (!sortValue) return;

    // Mark active
    var parent = option.closest('.spectrum-drawer');
    if (parent) {
      var allOptions = parent.querySelectorAll(SELECTORS.sortOption);
      for (var i = 0; i < allOptions.length; i++) {
        allOptions[i].classList.remove('is-active');
      }
    }
    option.classList.add('is-active');

    closeAllDrawers();

    // Update URL with sort_by param
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    triggerNavigation(url.pathname + url.search);
  }

  function triggerNavigation(url) {
    // The existing DynamicProductSearch custom element listens for
    // clicks on .js-filter-trigger links. We create a temporary anchor,
    // give it the right class and href, and click it programmatically.
    var dynamicSearch = document.querySelector(SELECTORS.dynamicSearch);
    if (!dynamicSearch) {
      window.location.href = url;
      return;
    }

    var tempLink = document.createElement('a');
    tempLink.href = url;
    tempLink.className = 'js-filter-trigger';
    tempLink.style.display = 'none';
    dynamicSearch.appendChild(tempLink);
    tempLink.click();
    tempLink.remove();
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
